import { Component, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import UserInfo from '../UserInfo';
import SimpleMachineInfo from '../MachineInfo/SimpleMachineInfo';
import MultiThemeSource from '../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';
import TimeLabel from '../../../../../common/scripts/Toolkit/Components/Misc/TimeLabel';
import EnhanceAnimation from '../../../../../common/scripts/Toolkit/Components/Animation/EnhanceAnimation';
import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import { JackpotLevel } from '../../../../../tableEngine/Script/Game/Data/Model/LobbyJackpotModel';

const { ccclass, property } = _decorator;

@ccclass('JackpotRecord')
export default class JackpotRecord extends Component {
    @property(EnhanceAnimation)
    private readonly animation: EnhanceAnimation = null;

    @property(UserInfo)
    private readonly userInfo: UserInfo = null;

    @property(TimeLabel)
    private readonly timeLabel: TimeLabel = null;

    @property(SimpleMachineInfo)
    private readonly machineInfo: SimpleMachineInfo = null;

    @property(MultiThemeSource)
    private readonly themeSource: MultiThemeSource = null;

    public display(data: DataType.Jackpot.WinRecordData) {
        this.userInfo.balance = Lobby.account.valueToDollar(data.Win);
        this.userInfo.nickname = `Player ${data.PlayersID}`;
        this.userInfo.avatar = '';
        this.themeSource.theme = JackpotLevel.list().indexOf(data.Level);
        if (this.timeLabel) {
            this.timeLabel.time = Date.parse(data.CreatedAt);
        }
        if (this.machineInfo) {
            // TODO: undefined TableID
            this.machineInfo.updateInfo(data.ID, data.GameID);
        }
    }

    public playAnimation() {
        this.animation.play();
    }
}
